import { render, staticRenderFns } from "./CompanyMessagesEscalated.vue?vue&type=template&id=6fa46a69&scoped=true&"
import script from "./CompanyMessagesEscalated.vue?vue&type=script&lang=js&"
export * from "./CompanyMessagesEscalated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa46a69",
  null
  
)

export default component.exports